<div class="dls-footer p-3 p-md-4 p-lg-5">
  <div class="d-flex ws-para-1 mt-4 mt-lg-0 mb-1 text-center text-lg-left">
    WellSky DLS is an evolving system of guidelines, components, and resources that support the best practices of
    user interface design in our digital products for WellSky. Backed by Atlas UI, the WellSky DLS streamlines
    collaboration between designers and developers, and helps teams quickly build beautiful and consistent
    products.
  </div>
  <div class="d-flex justify-content-center justify-content-lg-start ws-para-1 mb-3 resource-links">
    <a
      href="https://github.com/mediwareinc/Atlas.UI"
      target="_blank"
      (click)="captureClick($event)">
        GitHub
    </a>
    <span class="mx-4">/</span>
    <!-- TODO: Take to Contribution page once created -->
    <a
      href="mailto:ux@wellsky.com"
      target="_self"
      (click)="captureClick($event)">
        Contact Us
    </a>
  </div>
  <div class="d-flex justify-content-center">
    <span class="copyright">
      Copyright © 2020 WellSky. All rights reserved. <br class="d-block d-lg-none" />
      <a
        href="https://wellsky.com/terms-of-use/"
        target="_blank"
        (click)="captureClick($event)">Terms of use</a>
       |
      <a
        href="https://wellsky.com/patents/"
        target="_blank"
        (click)="captureClick($event)">Patents</a>
       |
      <a
        href="https://wellsky.com/privacy-policy/"
        target="_blank"
        (click)="captureClick($event)">Privacy policy</a>
    </span>
  </div>
</div>